export enum CustomEventLocation {
  LANDING_PAGE = "Landing Page",
  BLOG_PAGE = "Blog Page",
  CATEGORY_PAGE = "Category Page",
  PROJECT_PAGE = "Project Page",
  SEARCH_RESULTS_PAGE = "Search Results Page",
  WEB_SHOP_PAGE = "Web Shop Page",
  OTHER_WEBSITE_PAGE = "Other Website Page",
  PRODUCT_DETAILS_PAGE = "Product Details Page",
  PRODUCT_SPOTLIGHT = "Product Spotlight",
  CATEGORY_CARD = "Category Card",
  CTA = "CTA",
}
